<div class="main-group">
	<!--			-->
	<!-- Item Count -->
	<!--			-->
	<div class="main-group-item">
		<div class="main-group-item-center">
			<label class="label-item-total">{{ ItemsChangedMessage }}</label>
		</div>
	</div>

	<!--	   -->
	<!-- Fee   -->
	<!--	   -->
	<div class="main-group-item">
		<div class="selector-item">
			<div>
				<label class="label-item">Fee Amount</label>
			</div>

			<div style="margin-left: 10px; width: 75px">
				<p-inputNumber
					class="p-inputtext-lg"
					[(ngModel)]="FeeAmount"
					inputId="currency-us"
					mode="currency"
					currency="USD"
					locale="en-US"
				></p-inputNumber>
			</div>
		</div>
	</div>

	<!--	   -->
	<!-- Notes -->
	<!--	   -->
	<div class="main-group-item">
		<div>
			<label class="label-item">Note:</label>
			<label style="margin-left: 10px; margin-top: 0px"
				>Any print queue records that were selected that did not have the status of [Review Pending] have been prefiltered.</label
			>
			<label style="margin-left: 10px; margin-top: 10px"
				>Any print queue records that were selected whose Audience type is not [Student] have also been prefiltered.</label
			>
		</div>
	</div>

	<!--				-->
	<!-- Error Message  -->
	<!--				-->
	<div class="main-group-item" [style.display]="ErrorMessage != '' ? 'block' : 'none'">
		<div>
			<label class="error-message">{{ ErrorMessage }}</label>
		</div>
	</div>
</div>

<!-- 		 -->
<!-- Buttons -->
<!-- 		 -->
<div style="margin-top: 20px">
	<button class="btn btn-primary" style="margin-left: 0px" [disabled]="isBusy == true" (click)="onSetFee()">Ok</button>
	<button class="btn btn-primary" style="margin-left: 5px" (click)="onClose()">Cancel</button>
</div>
